/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrightsmithDb = void 0;

var BrightsmithDb = /*#__PURE__*/function () {
  function BrightsmithDb(api, schema) {
    var _this = this;

    _classCallCheck(this, BrightsmithDb);

    var _a;

    this.configuration = {};
    this.db = {};
    this.overrides = {};
    this.configuration = api.configuration;
    this.db = api.data;
    this.overrides = {};
    this.schema = schema;
    (_a = api.overrides) === null || _a === void 0 ? void 0 : _a.map(function (o) {
      var collection = o.collection;

      if (!_this.overrides[collection]) {
        _this.overrides[collection] = [];
      }

      _this.overrides[collection].push(o);
    });
  }

  _createClass(BrightsmithDb, [{
    key: "calculateTotalPrice",
    value: function calculateTotalPrice(configuration, model) {
      var _this2 = this;

      var countryCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'US';
      var basePrice = this.getPrice(model, countryCode);
      Object.keys(configuration).forEach(function (attributeId) {
        var propertyId = configuration[attributeId];

        var attribute = _this2.getAttribute(attributeId);

        var property = _this2.getProperty(propertyId);

        if ('price' in attribute) {
          var price = _this2.getPrice(attribute, countryCode);

          basePrice += price;
        }

        if ('price' in property && !property.included) {
          var _price = _this2.getPrice(property, countryCode);

          basePrice += _price;
        }
      });
      return basePrice;
    }
  }, {
    key: "clone",
    value: function clone(entry) {
      try {
        return JSON.parse(JSON.stringify(entry));
      } catch (e) {
        console.warn("Error cloning entry ".concat(entry));
      }
    }
  }, {
    key: "getEntry",
    value: function getEntry(tableName, id) {
      var table = this.getTable(tableName);

      if (!table[id]) {
        return {};
      }

      var entry = this.clone(table[id]);
      var overrides = this.getOverrides(tableName);
      overrides.forEach(function (o) {
        var property = o.property,
            value = o.value;

        if (id === o.id) {
          entry[property] = value;
        }
      });
      return entry;
    }
  }, {
    key: "getTable",
    value: function getTable(tableName) {
      var table = this.db[tableName] || {};
      var byId = table.byId || table;
      return byId;
    }
  }, {
    key: "getAllData",
    value: function getAllData() {
      return this.db;
    }
  }, {
    key: "getAttribute",
    value: function getAttribute(id) {
      return this.getEntry('attributes', id);
    }
  }, {
    key: "getAttributes",
    value: function getAttributes() {
      return Object.values(this.getTable('attributes'));
    }
  }, {
    key: "getAttributesFromConfiguration",
    value: function getAttributesFromConfiguration(configuration) {
      var _this3 = this;

      var map = {};
      Object.keys(configuration).forEach(function (id) {
        map[id] = _this3.getAttribute(id);
      });
      return map;
    }
  }, {
    key: "getCategories",
    value: function getCategories() {
      return Object.values(this.getTable('categories'));
    }
  }, {
    key: "getCategory",
    value: function getCategory(id) {
      return this.getEntry('categories', id);
    }
  }, {
    key: "getConfiguration",
    value: function getConfiguration() {
      return this.configuration;
    }
  }, {
    key: "getDealer",
    value: function getDealer() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return this.getEntry('dealers', id);
    }
  }, {
    key: "getDealers",
    value: function getDealers() {
      return Object.values(this.getTable('dealers'));
    }
  }, {
    key: "getCurrentModel",
    value: function getCurrentModel() {
      return this.getModel(this.getCurrentModelId());
    }
  }, {
    key: "getCurrentModelId",
    value: function getCurrentModelId() {
      var _a, _b;

      var currentModelId = this.db.currentModelId || ((_a = this.getLastRequest().params) === null || _a === void 0 ? void 0 : _a.modelId) || ((_b = this.db) === null || _b === void 0 ? void 0 : _b.urlSlug) || '';

      if (!currentModelId) {
        console.warn('BrightsmithDb.getCurrentModelId called with no value returned', this.getLastRequest());
      }

      return currentModelId;
    }
  }, {
    key: "getLastRequest",
    value: function getLastRequest() {
      var _a;

      return ((_a = this.db) === null || _a === void 0 ? void 0 : _a.request) || {};
    }
  }, {
    key: "getModel",
    value: function getModel() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return this.getEntry('model', id);
    }
  }, {
    key: "getModels",
    value: function getModels() {
      return Object.values(this.getTable('model'));
    }
  }, {
    key: "getOverrides",
    value: function getOverrides(tableName) {
      return this.overrides[tableName] || [];
    }
  }, {
    key: "getPrice",
    value: function getPrice(entry) {
      var countryCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'US';
      var price = entry.price;

      if (price) {
        if (typeof price === 'number') {
          return price;
        }

        return price[countryCode] || 0;
      }

      return 0;
    }
  }, {
    key: "getProperties",
    value: function getProperties() {
      return Object.values(this.getTable('properties'));
    }
  }, {
    key: "getPropertiesFromConfiguration",
    value: function getPropertiesFromConfiguration(configuration) {
      var _this4 = this;

      var map = {};
      Object.values(configuration).forEach(function (id) {
        map[id] = _this4.getProperty(id);
      });
      return map;
    }
  }, {
    key: "getProperty",
    value: function getProperty(id) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var property = this.getEntry('properties', id);

      if (opts === null || opts === void 0 ? void 0 : opts.countryCode) {
        if (typeof property.price === 'object') {
          property.price = property.price[opts.countryCode];
        }
      }

      return property;
    }
  }, {
    key: "getProduct",
    value: function getProduct(id) {
      return this.getEntry('product', id);
    }
  }, {
    key: "getProducts",
    value: function getProducts() {
      return Object.values(this.getTable('product'));
    }
  }]);

  return BrightsmithDb;
}();

exports.BrightsmithDb = BrightsmithDb;